export enum EmployerType {
  FixedTerm = "fixedTerm",
  Permanent = "permanent",
}
